import { DefaultService } from "@/services/DefaultService";

class LicenciaConvenioService extends DefaultService {
  
  constructor() {
    super('licenciaconvenio');
  }
}

export default new LicenciaConvenioService;